import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import Component from '../../lib/component'
gsap.registerPlugin(ScrollTrigger)

export default class StickyNavComponent extends Component {
    static selector () {
        return '.sticky-nav'
    }

    constructor (opts) {
        super(opts)

        this.header = document
            .querySelector('#global-header')

        this.cssShow = 'sticky-nav-show'

        if (!this.header)
            return

        this.startPos = `${(this.header.offsetHeiaght || 150)
            + 50}px`

        this.render()
    }

    render () {
        ScrollTrigger.create({
            start: this.startPos,
            toggleClass: {
                targets: this.el,
                className: this.cssShow
            }
        })
    }
}
